/**
 * Created on 2017/2/23.充值订单部分的常量
 */
/**
 */
define('constant/agreement/agreement.constant',[], function () {
    return {
         frameAgreementTypes:[1000,1006,1016,1011,1229,1237],
         frameAgreements:[
               {roleId:'SMRole',agreementName:'华为开发者服务协议',agrType:1000},
               {roleId:'HilinkServiceRole',agreementName:'华为开发者服务协议',agrType:1000},
               {roleId:'VideoRole',agreementName:'华为开发者服务协议',agrType:1000},
               {roleId:'AdRole',agreementName:'付费展示平台合作协议',agrType:1016},
               {roleId:'PopProxyRole',agreementName:'华为应用市场付费推广代理商协议',agrType:1011},
               {roleId:'HWCloudRole',agreementName:'开发者联盟与华为云实名认证信息共享协议',agrType:1229}
         ]
    }
});

